import { Component } from 'react'
// Components
import { Button, IconCloseFat, Pill } from '@tracklib/kit'

// Types
import { Email as EmailType } from 'types'

import styles from './emailsform.css'

type Props = {
  email: EmailType
  resendVerification: (email: string) => void
  remove: (email: string) => void
  setPrimaryEmail: (email: string) => void
}

type State = {
  sent: boolean
}

class Email extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      sent: false,
    }
  }

  onResendVerification = () => {
    this.setState({ sent: true })
    this.props.resendVerification(this.props.email.email)
  }

  onRemove = () => {
    this.props.remove(this.props.email.email)
  }

  onMakePrimary = () => {
    this.props.setPrimaryEmail(this.props.email.email)
  }

  render() {
    const { email } = this.props
    const { email: emailAddress, primary, verified } = email

    const dataTestId = emailAddress ? emailAddress.split('@')[0] : ''
    return (
      <li className={styles.emailWrapper} datatesting={`email_entry_${dataTestId}`}>
        <div className={styles.email}>
          <div className={styles.info}>
            <span className={styles.emailRow}>
              <h4>{emailAddress}</h4>
            </span>
            {verified || (
              <p className={styles.emailAction}>
                Verification email sent.{' '}
                {this.state.sent ? (
                  'Email resent!'
                ) : (
                  <span className={styles.resendButton}>
                    <Button onClick={this.onResendVerification}>Resend</Button>
                  </span>
                )}
              </p>
            )}
          </div>
          {verified || <span className={styles.badge}>Unverified</span>}
          {primary && <Pill className={styles.primary}>Primary</Pill>}
          {verified && !primary && (
            <Button onClick={this.onMakePrimary} size="small" className={styles.makePrimary}>
              Make primary
            </Button>
          )}
        </div>
        {!primary && (
          <IconCloseFat
            title="Remove email"
            className={styles.delete}
            onClick={this.onRemove}
            datatesting={`button_remove_email_${dataTestId}`}
          />
        )}
      </li>
    )
  }
}

export default Email
